export const ROLE_OPERATE = "useradmin"; // 操作权限